import complexConfigurator from './complexConfigurator';
import renderUploadButton from './uploadButton';
import vp from './vp';

/* global $ */

function injectUploadButton() {
  // the script should only execute on product-first-flow
  if (complexConfigurator.projectAdapter.get('isDesignFirstFlow')) {
    return;
  }

  const featureId = 7556;
  const controlFeatureValue = 30026;
  const testFeatureValue = 30028;

  if (!window.utag_data) {
    // if we can't find utag_data, we won't be able to determine the user's feature values and we have to abort
    vp.logError('Unable to find utag_data');
    return;
  }

  const inControl = vp.activeFeatureValues.indexOf(controlFeatureValue.toString()) !== -1;
  const inTest = vp.activeFeatureValues.indexOf(testFeatureValue.toString()) !== -1;

  if (inControl || inTest) {
    vp.touchFeature(featureId);
  }

  // if we're not in the cell, we just evacuate at this point
  if (!inTest) {
    return;
  }

  renderUploadButton();
}

$(document).ready(injectUploadButton);
